import {
  SET_LOGIN_FAKE,
  CLEAR_LOGIN_FAKE
} from '../../../mutation-types'

const state = false

const getters = {}

const actions = {
  clear ({ commit }) {
    commit(CLEAR_LOGIN_FAKE, false)
  },

  setLoginFake ({ commit }, isLoginFakeActive) {
    commit(SET_LOGIN_FAKE, isLoginFakeActive)
    return isLoginFakeActive
  }

}

const mutations = {
  [SET_LOGIN_FAKE] (state, isLoginFakeActive) {
    state.isLoginFakeActive = isLoginFakeActive
  },

  [CLEAR_LOGIN_FAKE] (state) {
    state.isLoginFakeActive = false
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/publico/loginFake.js